import { EventConstant } from "@/const";
import { EventBusUtils } from "@/utils";

export const useLoading = () => {
  const openLoading = (open: boolean) => {
    EventBusUtils.emit<boolean>(EventConstant.GLOBAL_EVENTS.toggleOpenLoading, open);
  };

  return {
    openLoading,
  };
};
